// src/js/custom.js

// Ejemplo de función personalizada
function customFunction() {
    console.log("Custom function executed");
  }
  
  // Ejecutar la función cuando el documento esté listo
  document.addEventListener("DOMContentLoaded", customFunction);
  